import { gql } from '@apollo/client';
import { OrderItemDiscounts, ResponseStatus } from '@global/types/types';

interface CartDiscounts {
  orderItemDiscounts: OrderItemDiscounts[];
  couponTotalDiscount: number;
}

export interface GET_DISCOUNTS_RESPONSE {
  wGetCartDiscounts: {
    status: ResponseStatus;
    discounts: CartDiscounts;
  };
}

export const GET_DISCOUNTS = gql`
  query wGetCartDiscounts($uid: UUID) {
    wGetCartDiscounts(uid: $uid)
  }
`;
